/* HD Premium – Interaktionen & Animationen (ohne externe Bibliotheken) */
(function () {
  if (window.__HD_PREMIUM__) return;
  window.__HD_PREMIUM__ = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var body = document.body;

  /* ---- FX-Paket nachladen (Cursor, Intro-Steuerung, weiches Scrollen, Szenen) ---- */
  (function () {
    var me = document.currentScript || document.querySelector('script[src*="hd-premium.js"]');
    if (!me) return;
    var base = me.src.split('hd-premium.js')[0], q = me.src.split('hd-premium.js')[1] || '';
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = base + 'hd-fx.css' + q; document.head.appendChild(l);
    var s = document.createElement('script'); s.src = base + 'hd-fx.js' + q; s.defer = true; document.head.appendChild(s);
  })();

  /* ---- Header: transparent ganz oben auf der Startseite ---- */
  function onTop() { body.classList.toggle('hd-at-top', window.scrollY < 40); }
  onTop();
  window.addEventListener('scroll', onTop, { passive: true });

  /* ---- Reveal beim Scrollen ---- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }) : null;

  function observeReveals(scope) {
    var els = (scope || document).querySelectorAll('[data-hd-reveal],[data-hd-mask],[data-hd-lines]');
    els.forEach(function (el) {
      if (!io || reduce) { el.classList.add('is-in'); return; }
      io.observe(el);
    });
  }

  /* ---- Magnetische Buttons ---- */
  function magnetic(scope) {
    if (!finePointer || reduce) return;
    (scope || document).querySelectorAll('[data-hd-magnetic]').forEach(function (el) {
      if (el.__hdMag) return; el.__hdMag = true;
      el.addEventListener('pointermove', function (ev) {
        var r = el.getBoundingClientRect();
        var x = (ev.clientX - r.left - r.width / 2) * 0.25;
        var y = (ev.clientY - r.top - r.height / 2) * 0.35;
        el.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---- 3D-Neigung für Karten ---- */
  function tilt(scope) {
    if (!finePointer || reduce) return;
    (scope || document).querySelectorAll('[data-hd-tilt]').forEach(function (el) {
      if (el.__hdTilt) return; el.__hdTilt = true;
      var max = Number(el.getAttribute('data-hd-tilt')) || 6;
      el.addEventListener('pointermove', function (ev) {
        var r = el.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width - 0.5;
        var py = (ev.clientY - r.top) / r.height - 0.5;
        el.style.setProperty('--hd-rx', (-py * max).toFixed(2) + 'deg');
        el.style.setProperty('--hd-ry', (px * max).toFixed(2) + 'deg');
        el.style.setProperty('--hd-mx', ((px + 0.5) * 100).toFixed(1) + '%');
        el.style.setProperty('--hd-my', ((py + 0.5) * 100).toFixed(1) + '%');
      });
      el.addEventListener('pointerleave', function () {
        el.style.setProperty('--hd-rx', '0deg'); el.style.setProperty('--hd-ry', '0deg');
      });
    });
  }

  /* ---- Scroll-gesteuerte Effekte (ein gemeinsamer rAF-Loop) ---- */
  var scrollItems = [];
  function registerScroll(scope) {
    (scope || document).querySelectorAll('[data-hd-parallax],[data-hd-words],[data-hd-pin]').forEach(function (el) {
      if (el.__hdScroll) return; el.__hdScroll = true;
      if (el.hasAttribute('data-hd-words')) prepWords(el);
      scrollItems.push(el);
    });
    requestTick();
  }

  function prepWords(el) {
    var target = el.querySelector('[data-hd-words-target]') || el;
    if (target.__hdSplit) return; target.__hdSplit = true;
    var words = target.textContent.trim().split(/\s+/);
    target.textContent = '';
    words.forEach(function (w, i) {
      var s = document.createElement('span');
      s.className = 'hd-word'; s.textContent = w;
      target.appendChild(s);
      if (i < words.length - 1) target.appendChild(document.createTextNode(' '));
    });
    el.__hdWords = target.querySelectorAll('.hd-word');
  }

  function progress(el, startVh, endVh) {
    var r = el.getBoundingClientRect(), vh = window.innerHeight;
    var start = vh * startVh, end = -r.height + vh * endVh;
    return Math.max(0, Math.min(1, (start - r.top) / (start - end)));
  }

  var ticking = false;
  function requestTick() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

  function update() {
    ticking = false;
    var vh = window.innerHeight;
    scrollItems.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -vh * 0.5 || r.top > vh * 1.5) return;

      if (el.hasAttribute('data-hd-parallax') && !reduce) {
        var speed = Number(el.getAttribute('data-hd-parallax')) || 0.12;
        var center = r.top + r.height / 2 - vh / 2;
        el.style.transform = 'translate3d(0,' + (center * -speed).toFixed(1) + 'px,0) scale(1.12)';
      }

      if (el.__hdWords) {
        var p = reduce ? 1 : progress(el, 0.85, 0.45);
        var n = el.__hdWords.length, lit = p * n;
        for (var i = 0; i < n; i++) {
          var o = Math.max(0, Math.min(1, lit - i));
          el.__hdWords[i].style.opacity = (0.16 + o * 0.84).toFixed(3);
        }
      }

      if (el.hasAttribute('data-hd-pin')) pinUpdate(el, r, vh);
    });
  }

  /* ---- Horizontal-Scroll (Kollektions-Welten) ---- */
  var desktop = window.matchMedia('(min-width: 990px)');
  function pinSetup(el) {
    var track = el.querySelector('[data-hd-track]');
    if (!track) return;
    if (!desktop.matches || reduce) { el.style.height = ''; track.style.transform = ''; el.classList.remove('is-pinned'); return; }
    var dist = Math.max(0, track.scrollWidth - window.innerWidth + 40);
    el.__hdDist = dist;
    el.style.height = (window.innerHeight + dist) + 'px';
    el.classList.add('is-pinned');
  }
  function pinUpdate(el, r, vh) {
    var track = el.querySelector('[data-hd-track]');
    if (!track || !el.classList.contains('is-pinned')) return;
    var total = Math.max(1, el.offsetHeight - vh);
    var p = Math.max(0, Math.min(1, -r.top / total));
    track.style.transform = 'translate3d(' + (-p * el.__hdDist).toFixed(1) + 'px,0,0)';
    var bar = el.querySelector('[data-hd-progress]');
    if (bar) bar.style.transform = 'scaleX(' + p.toFixed(3) + ')';
  }
  function pinAll() { document.querySelectorAll('[data-hd-pin]').forEach(pinSetup); requestTick(); }

  /* ---- Header-Logo: 3D-Gold, dreht sich einmal pro Minute ---- */
  function headerLogo() {
    var cfg = window.HD_LOGO || { rest: '/cdn/shop/files/hd-logo-rest.webp', spin: '/cdn/shop/files/hd-logo-spin.webp', cols: 8, rows: 7, frames: 55, fps: 22, every: 60 };
    var img = document.querySelector('.header__heading-logo');
    if (!img || img.__hdLogo) return;
    img.__hdLogo = true;
    var rest = new Image();
    rest.onload = function () {
      var wrap = document.createElement('span'); wrap.className = 'hd-hlogo-wrap';
      var box = document.createElement('span'); box.className = 'hd-hlogo'; box.setAttribute('aria-hidden', 'true');
      var still = document.createElement('span'); still.className = 'hd-hlogo__rest';
      var spin = document.createElement('span'); spin.className = 'hd-hlogo__spin';
      still.style.backgroundImage = 'url("' + cfg.rest + '")';
      box.appendChild(still); box.appendChild(spin);
      img.parentNode.insertBefore(wrap, img); wrap.appendChild(img); wrap.appendChild(box);
      wrap.classList.add('is-ready');
      if (reduce) return;

      var sheet = new Image(), running = false;
      function frame(n) {
        var c = n % cfg.cols, r = Math.floor(n / cfg.cols);
        spin.style.backgroundPosition = (c / (cfg.cols - 1) * 100).toFixed(3) + '% ' + (r / (cfg.rows - 1) * 100).toFixed(3) + '%';
      }
      function play() {
        if (running || document.hidden || document.documentElement.classList.contains('hd-intro-lock')) return;
        running = true; frame(0); box.classList.add('is-spinning');
        var t0 = performance.now(), dur = cfg.frames / cfg.fps * 1000;
        (function step(now) {
          var n = Math.min(cfg.frames - 1, Math.floor((now - t0) / dur * cfg.frames));
          frame(n);
          if (n < cfg.frames - 1) requestAnimationFrame(step);
          else { box.classList.remove('is-spinning'); running = false; }
        })(t0);
      }
      sheet.onload = function () {
        spin.style.backgroundImage = 'url("' + cfg.spin + '")';
        spin.style.backgroundSize = (cfg.cols * 100) + '% ' + (cfg.rows * 100) + '%';
        /* erste Drehung kurz nach dem Laden (bzw. nach dem Intro), danach jede Minute */
        (function first() {
          if (document.documentElement.classList.contains('hd-intro-lock')) return setTimeout(first, 400);
          setTimeout(play, 1200);
        })();
        setInterval(play, (cfg.every || 60) * 1000);
      };
      var go = function () { sheet.src = cfg.spin; };
      if (document.readyState === 'complete') setTimeout(go, 300); else window.addEventListener('load', function () { setTimeout(go, 300); });
    };
    rest.src = cfg.rest;
  }

  /* ---- Transparentes Logo-Video (oben Farbe, unten Maske) – spielt genau einmal ---- */
  function alphaVideos(scope) {
    (scope || document).querySelectorAll('[data-hd-alpha-video]').forEach(function (box) {
      if (box.__hdAlpha) return; box.__hdAlpha = true;
      var still = box.querySelector('img');
      var showStill = function () { box.classList.add('is-still'); };
      var canvas = document.createElement('canvas');
      var gl = canvas.getContext('webgl', { premultipliedAlpha: true, alpha: true, antialias: false });
      if (!gl || reduce) { showStill(); return; }
      var vs = 'attribute vec2 p;varying vec2 uv;void main(){uv=vec2((p.x+1.)*.5,(1.-p.y)*.5);gl_Position=vec4(p,0.,1.);}';
      var fs = 'precision mediump float;uniform sampler2D t;varying vec2 uv;void main(){vec3 c=texture2D(t,vec2(uv.x,uv.y*.5)).rgb;float a=texture2D(t,vec2(uv.x,.5+uv.y*.5)).g;a=clamp((a-.04)/.92,0.,1.);gl_FragColor=vec4(c*a,a);}';
      function sh(type, src) { var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); return s; }
      var prog = gl.createProgram();
      gl.attachShader(prog, sh(gl.VERTEX_SHADER, vs)); gl.attachShader(prog, sh(gl.FRAGMENT_SHADER, fs)); gl.linkProgram(prog);
      if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) { showStill(); return; }
      gl.useProgram(prog);
      var buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
      var loc = gl.getAttribLocation(prog, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
      var tex = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, tex);
      [gl.TEXTURE_WRAP_S, gl.TEXTURE_WRAP_T].forEach(function (k) { gl.texParameteri(gl.TEXTURE_2D, k, gl.CLAMP_TO_EDGE); });
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);

      var v = document.createElement('video');
      v.crossOrigin = 'anonymous'; v.muted = true; v.playsInline = true; v.preload = 'auto';
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
      v.className = 'hd-alpha__src';
      var broken = false;
      function draw() {
        if (broken || v.readyState < 2) return;
        var w = v.videoWidth, h = v.videoHeight / 2;
        if (canvas.width !== w || canvas.height !== h) { canvas.width = w; canvas.height = h; gl.viewport(0, 0, w, h); }
        try { gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, v); }
        catch (e) { broken = true; showStill(); return; }
        gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT); gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        box.classList.add('is-live');
      }
      function loop() {
        draw();
        if (v.paused || v.ended) return;
        if (v.requestVideoFrameCallback) v.requestVideoFrameCallback(loop); else requestAnimationFrame(loop);
      }
      v.addEventListener('loadeddata', draw);
      v.addEventListener('playing', loop);
      v.addEventListener('ended', function () { draw(); box.classList.add('is-done'); });
      v.addEventListener('error', showStill);
      box.appendChild(v); box.appendChild(canvas);
      v.src = box.getAttribute('data-src');

      var started = false;
      function start() {
        if (started || document.hidden || document.documentElement.classList.contains('hd-intro-lock')) return;
        started = true;
        var p = v.play(); if (p && p.catch) p.catch(function () { started = false; });
      }
      var delay = Number(box.getAttribute('data-delay')) || 400;
      var go = function () { setTimeout(start, delay); };
      if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
      document.addEventListener('visibilitychange', function () { if (!document.hidden) start(); });
      setTimeout(function () { if (!box.classList.contains('is-live')) showStill(); }, 6000);
    });
  }

  function init(scope) {
    headerLogo();
    alphaVideos(scope);
    observeReveals(scope); magnetic(scope); tilt(scope); registerScroll(scope); pinAll();
  }

  window.addEventListener('scroll', requestTick, { passive: true });
  var rz; window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(pinAll, 150); }, { passive: true });
  window.addEventListener('load', pinAll);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
